import React from 'react'
import PropTypes from 'prop-types'
import ModalBackground from './ModalBackground'

/* doc
---
title: Modal
name: Modal
category: React - Bulma
---

A `Modal` component based on Bulma `.modal`. This is used to display a modal
to the user.

This should be used with `ModalCard/ModalContent` components.

See [Bulma Documentation](http://bulma.io/documentation/components/modal/) for reference and full options.

```html_example
  <Modal>
    <ModalBackground />
    <ModalContent>
      ...
    </ModalContent>
  </Modal>
```
*/
class Modal extends React.Component {
  constructor(props) {
    super(props)
    this.closeOnEsc = this.closeOnEsc.bind(this)
  }

  closeOnEsc(event) {
    if (event.keyCode === 27) {
      this.props.onClose()
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.closeOnEsc, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.closeOnEsc, false)
  }

  render() {
    const {
      className, children, isActive, onClose, ...rest
    } = this.props

    const classes = [
      'bulma-modal',
      className || '',
      isActive ? 'is-active' : '',
    ]

    return (
      <div {...rest} className={classes.join(' ')}>
        <ModalBackground onClick={onClose} />
        {children}
      </div>
    )
  }
}

Modal.defaultProps = {
  isActive: false,
  onClose: null,
}

Modal.propTypes = {
  // If the modal is active or not
  isActive: PropTypes.bool,
  // The function for the ModalBackground.
  onClose: PropTypes.func,
}

export default Modal
